// Module
var code = `<div>
	<div class="form-group">
		<div class="dropdown">
			<a href="#" class="btn dropdown-toggle btn-secondary text-right btn-block" data-toggle="dropdown">
				<span class="pull-left" data-bind="text: compareOption().text"></span>
			</a>
			<div class="dropdown-menu" style="width: 100%" data-bind="foreach: compareOptions">
				<div class="dropdown-item" data-bind="text: text, click: \$root.clickedChangeFilter"></div>
			</div>
		</div>
	</div>
	<!-- ko if: compareOption() && !compareOption().compareValue -->
	<div class="form-group">
		<!-- ko if: compareOption().list -->
		<div class="filterList">
			<div class="search">
				<div class="wrapper">
					<i class="input-icon fa fa-search"></i>
					<input type="text" class="form-control search-input" data-bind="textInput: search, attr:{ placeholder: placeholderText }">
				</div>
			</div>
			<div class="results">
				<!-- ko foreach: { data: filteredValues, afterRender: \$root.bindSelectItems } -->
				<div class="dropdown-item text-truncate custom-filter-dropdown-item" data-bind="click: \$root.clickedSelect.bind(\$root), attr:{ title: description }">
					<input type="checkbox" data-bind="checkedValue: \$data._id, checked: \$root.selection, attr:{ id: \$root.getUniqueId(\$data._id) }">
					<label data-bind="attr:{ for: \$root.getUniqueId(\$data._id) }">
						<span data-bind="html: name"></span>
						<!-- ko if: \$data.count -->
						<small class="pull-right text-muted" data-bind="text: count"></small>
						<!-- /ko -->
					</label>
				</div>
				<!-- /ko -->
				<!-- ko if: !isBusy() && filteredValues().length == 0  -->
				<div class="dropdown-item no-results">
					<div>
						<!-- ko if: values().length == 0 -->
						No <span data-bind="text: field.name.toLowerCase()"></span> data found
						<!-- /ko -->
						<!-- ko ifnot: values().length == 0 -->
						No <span data-bind="text: field.name.toLowerCase()"></span> found with
						<strong data-bind="text: \$root.search"></strong>
						<!-- /ko -->
					</div>
				</div>
				<!-- /ko -->
				<!-- ko if: isBusy() -->
				<div class="dropdown-item loading">Loading...</div>
				<!-- /ko -->
			</div>
		</div>
		<!-- /ko -->
		<!-- ko if: !compareOption().list && compareOption().compareValue == null -->
		<!-- ko if: ['date', 'datetime'].indexOf(field.kind) != -1 -->
		<button class="btn btn-secondary btn-block text-left btn-datepicker">
			<span class="fa fa-calendar"></span>
			<span data-bind="html: moment(compareValue()).format('D MMMM YYYY') || '<i>Pick a date</i>'"></span>
		</button>
		<!-- /ko -->
		<!-- ko if: ['date', 'datetime'].indexOf(field.kind) == -1 -->
		<input type="text" class="form-control text-input" data-bind="textInput: compareValue, attr:{ type: compareValueKind }">
		<!-- /ko -->
		<!-- /ko -->
	</div>
	<!-- /ko -->
	<div class="text-right">
		<button class="btn btn-icon btn-danger" style="padding: 0.25rem 0.5rem; float: left" aria-label="Remove filter" data-bind="click: clickedRemove">
			<svg width="20" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M6 10L6.91732 20.0905C6.96415 20.6056 7.39601 21 7.91321 21H16.0868C16.604 21 17.0359 20.6056 17.0827 20.0905L18 10M4 7H9M20 7H15M10 17V11.5M14 17V11.5M9 7V5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7M9 7H15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		</button>
		<button class="btn btn-secondary" data-bind="click: clickedClear, attr:{ disabled: !canClear() }">Clear</button>
		<button class="btn btn-primary" data-bind="click: clickedFilter, attr:{ disabled: !canFilter() }">Apply</button>
	</div>
</div>
`;
// Exports
export default code;